import { Calculator } from "@/features/calculator";
import "./index.css";

export function App() {
  return <Calculator />;
}

export default App;
